<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-3"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-blue-50 p-3 border-1 border-blue-100 border-round-lg">
            <i class="pi pi-envelope text-blue-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.EMAIL.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.EMAIL.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div *ngIf="visibleTabs().length > 1" class="tab-nav tab-nav--centered w-full">
         <button
            *ngFor="let tab of visibleTabs()"
            type="button"
            class="tab-nav__item"
            [class.tab-nav__item--active]="activeTab() === tab.value"
            (click)="activeTab.set(tab.value)"
         >
            <lucide-icon *ngIf="tab.value === 'preview'" name="eye" [size]="15"></lucide-icon>
            <lucide-icon *ngIf="tab.value === 'config'" name="settings" [size]="15"></lucide-icon>
            <span>{{ tab.label }}</span>
         </button>
      </div>
   </div>

   <!-- Preview tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
         <div class="flex justify-content-center">
            <div
               class="email-mockup shadow-4 border-round-xl bg-white overflow-hidden flex flex-column w-full max-w-30rem"
            >
               <div class="email-header bg-gray-100 p-3 border-bottom-1 border-200">
                  <div class="flex flex-column gap-2">
                     <div class="flex justify-content-between align-items-center">
                        <span class="text-xs font-bold text-700"
                           >{{ 'DATA.MODULES.INSPECTORS.EMAIL.PREVIEW.SENDER_LABEL' | translate }}: Paymefy</span
                        >
                        <span class="text-xs text-500">10:45 AM</span>
                     </div>
                     <div class="text-sm font-semibold text-800">
                        {{ 'DATA.MODULES.INSPECTORS.EMAIL.PREVIEW.SUBJECT_LABEL' | translate }}:
                        {{ previewSubject() || '...' }}
                     </div>
                  </div>
               </div>

               <div class="email-content p-4 bg-white flex-grow-1 overflow-y-auto min-h-15rem">
                  <div
                     *ngIf="previewMessage()"
                     class="text-sm text-700 line-height-3"
                     [innerHTML]="previewMessage()"
                  ></div>

                  <div
                     *ngIf="!previewMessage()"
                     class="flex flex-column align-items-center justify-content-center h-full text-400 opacity-60 italic py-5"
                  >
                     <i class="pi pi-envelope text-4xl mb-2"></i>
                     <span>{{ 'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.TEMPLATE_HELP' | translate }}</span>
                  </div>
               </div>

               <div class="email-footer bg-gray-50 p-3 border-top-1 border-200 text-center text-xs text-500">
                  {{ 'DATA.MODULES.INSPECTORS.EMAIL.PREVIEW.FOOTER' | translate }}
               </div>
            </div>
         </div>

         <div class="flex flex-column gap-3">
             <div
                 class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
             >
                 <div class="bg-blue-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                     <i class="pi pi-envelope text-blue-700 text-lg"></i>
                 </div>

                 <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{ 'DATA.MODULES.INSPECTORS.EMAIL.PREVIEW.SELECTED_EMAIL' | translate }}</span>
                     <span class="text-xl font-semibold text-blue-800">
                     {{ selectedTemplateName() }}
                  </span>
                 </div>
             </div>

            <div
               class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
            >
               <div class="bg-teal-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-clock text-teal-700 text-lg"></i>
               </div>

               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.EMAIL.PREVIEW.EXPIRATION_LABEL' | translate
                  }}</span>
                  <span class="text-blue-800 font-semibold text-xl" *ngIf="expirationMode() === 'days'">
                     {{ 'DATA.MODULES.INSPECTORS.EMAIL.PREVIEW.EXPIRES_IN' | translate }}
                     {{ expirationDays() ?? 0 }}
                     {{
                        (expirationDays() ?? 0) === 1
                           ? ('DATA.COMMON.TIME.DAY' | translate)
                           : ('DATA.COMMON.TIME.DAYS' | translate)
                     }}
                  </span>
                  <span class="text-blue-800 font-semibold text-xl" *ngIf="expirationMode() === 'date'">
                     {{ expirationAt() | date: 'dd/MM/yyyy' }}
                  </span>
               </div>
            </div>

            <div
               class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
            >
               <div class="bg-cyan-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-send text-cyan-700 text-lg"></i>
               </div>

               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.EMAIL.PREVIEW.SEND_TO_ALL_LABEL' | translate
                  }}</span>
                  <span class="text-xl font-semibold text-blue-800">
                     {{ sendToAllContacts() ? ('GLOBAL.YES' | translate) : ('GLOBAL.NO' | translate) }}
                  </span>
               </div>
            </div>

            <div
               class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
            >
               <div class="bg-cyan-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-at text-cyan-700 text-lg"></i>
               </div>

               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.EMAIL.PREVIEW.SEND_CC_LABEL' | translate
                  }}</span>
                  <span class="text-xl font-semibold text-blue-800">
                     {{ sendCarbonCopyToAllContacts() ? ('GLOBAL.YES' | translate) : ('GLOBAL.NO' | translate) }}
                  </span>
               </div>
            </div>

            <div *ngIf="errors().length" class="mt-4">
               <div *ngFor="let e of errors()" class="text-red-600 text-sm">{{ e.errorMessage }}</div>
            </div>
         </div>
      </div>
   </div>

   <!-- Config tab -->
   <div *ngIf="activeTab() === 'config'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
         <div class="flex flex-column gap-2">
            <label class="font-semibold text-800">{{
               'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.TEMPLATE_LABEL' | translate
            }}</label>
            <span class="text-500 text-sm mb-1">{{
               'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.TEMPLATE_HELP' | translate
            }}</span>
            <p-dropdown
               [options]="templates()"
               [ngModel]="selectedTemplateId()"
               (ngModelChange)="onTemplateChange($event)"
               optionLabel="name"
               optionValue="id"
               [placeholder]="'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.TEMPLATE_PLACEHOLDER' | translate"
               styleClass="w-full"
               [filter]="true"
               appendTo="body"
            ></p-dropdown>

            <div *ngIf="editTemplateUrl()" class="flex justify-content-end mt-1">
               <a
                  [href]="editTemplateUrl()"
                  target="_blank"
                  class="text-xs text-blue-600 hover:text-blue-800 font-medium no-underline flex align-items-center gap-1"
               >
                  <i class="pi pi-external-link"></i>
                  {{ 'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.EDIT_TEMPLATE' | translate }}
               </a>
            </div>
         </div>

         <div *ngIf="previewMessage()" class="mt-1">
            <div class="bg-blue-50 p-3 border-round-lg border-1 border-blue-200">
               <div class="font-semibold text-700 mb-2 flex align-items-center gap-2">
                  <i class="pi pi-align-left"></i>
                  {{ selectedTemplateName() }}
               </div>
               <div class="text-xs font-semibold text-600 mb-1">
                  {{ 'DATA.MODULES.INSPECTORS.EMAIL.PREVIEW.SUBJECT_LABEL' | translate }}: {{ previewSubject() }}
               </div>
               <div
                  class="text-700 line-height-3 whitespace-pre-wrap text-sm max-h-10rem overflow-y-auto"
                  [innerHTML]="previewMessage()"
               ></div>
            </div>
         </div>

         <p-divider></p-divider>

         <div class="flex flex-column gap-3">
            <label class="font-semibold text-800">{{
               'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.EXPIRATION_MODE_LABEL' | translate
            }}</label>

            <div class="flex gap-4">
               <div class="flex align-items-center">
                  <p-radioButton
                     name="expMode"
                     value="days"
                     [ngModel]="expirationMode()"
                     (ngModelChange)="onExpirationModeChange($event)"
                     inputId="expDays"
                  ></p-radioButton>
                  <label for="expDays" class="ml-2 cursor-pointer">{{
                     'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.EXPIRATION_MODE_DAYS' | translate
                  }}</label>
               </div>
               <div class="flex align-items-center">
                  <p-radioButton
                     name="expMode"
                     value="date"
                     [ngModel]="expirationMode()"
                     (ngModelChange)="onExpirationModeChange($event)"
                     inputId="expDate"
                  ></p-radioButton>
                  <label for="expDate" class="ml-2 cursor-pointer">{{
                     'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.EXPIRATION_MODE_DATE' | translate
                  }}</label>
               </div>
            </div>

            <div *ngIf="expirationMode() === 'days'" class="flex flex-column gap-2 mt-2">
               <p-inputNumber
                  type="number"
                  min="0"
                  max="365"
                  styleClass="w-full"
                  [ngModel]="expirationDays()"
                  (ngModelChange)="onExpirationDaysChange($event)"
                  [suffix]="'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.DAYS_SUFFIX' | translate"
               />
            </div>

            <div *ngIf="expirationMode() === 'date'" class="flex flex-column gap-2 mt-2">
               <p-calendar
                  [ngModel]="expirationAt()"
                  (ngModelChange)="onExpirationAtChange($event)"
                  [showIcon]="true"
                  appendTo="body"
                  styleClass="w-full"
                  [minDate]="today"
                  dateFormat="dd/mm/yy"
                  placeholder="dd/mm/yyyy"
               ></p-calendar>
            </div>
         </div>

         <p-divider></p-divider>

         <div class="flex align-items-center justify-content-between">
            <div class="flex flex-column gap-1">
               <label class="font-semibold text-800">{{
                  'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.SEND_TO_ALL_LABEL' | translate
               }}</label>
               <span class="text-500 text-xs">{{
                  'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.SEND_TO_ALL_HELP' | translate
               }}</span>
            </div>
            <p-inputSwitch
               [ngModel]="sendToAllContacts()"
               (ngModelChange)="onSendToAllContactsChange($event)"
            ></p-inputSwitch>
         </div>

         <div class="flex align-items-center justify-content-between">
            <div class="flex flex-column gap-1">
               <label class="font-semibold text-800">{{
                  'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.SEND_CC_LABEL' | translate
               }}</label>
               <span class="text-500 text-xs">{{
                  'DATA.MODULES.INSPECTORS.EMAIL.CONFIG.SEND_CC_HELP' | translate
               }}</span>
            </div>
            <p-inputSwitch
               [ngModel]="sendCarbonCopyToAllContacts()"
               (ngModelChange)="onSendCarbonCopyToAllContactsChange($event)"
            ></p-inputSwitch>
         </div>

         <div *ngIf="errors().length">
            <div *ngFor="let e of errors()" class="text-red-600 text-sm">{{ e.errorMessage }}</div>
         </div>
      </div>
   </div>
</div>
